<template>
  <div class="regist">
    <div class="regist-content">
      <div class="regist-title">
        <p>企业注册</p>
      </div>
      <el-card class="box-card">
        <div>
          <el-row type="flex" class="row-bg">
            <el-col :span="16">
              <el-form
                ref="form"
                :model="Data.company"
                :rules="formRules"
                class="queryform"
                style="width:500px;"
              >
                <el-form-item prop="Uname" label="登录账号">
                  <el-input v-model="Data.company.Uname" placeholder="请输入用户名" size="small" @blur="blurUserName(Data.company.Uname)"></el-input>
                </el-form-item>
                <el-form-item prop="Pass" label="登录密码" size="mini ">
                  <el-input
                    v-model="Data.company.Pass"
                    :type="pwdType"
                    autocomplete="off"
                    placeholder="包含8位及以上的数字、大小写字母及特殊符合"
                    size="small"
                  >
                  <i slot="suffix" id="PassView" class="el-icon-view" @click="showPwd"></i>
                  </el-input>

                <!-- 密码强度提示 -->
                <el-form-item>
                    <div id="tips" v-if="Data.company.Pass.length>0"><span></span><span></span><span></span><span></span></div>
                </el-form-item>

                </el-form-item>
                <el-form-item prop="Name" label="企业名称">
                  <el-input v-model="Data.company.Name" size="small" placeholder="请输入企业名称" @blur="blurName(Data.company.Name)"></el-input>
                </el-form-item>
                <el-form-item prop="RegistCode" label="社会统一信用代码">
                  <el-input v-model="Data.company.RegistCode" size="small" placeholder="请输入社会统一信用代码" @blur="blurRegistCodeName(Data.company.RegistCode)"></el-input>
                </el-form-item>
                <el-form-item prop="License" label="许可证号">
                  <el-input v-model="Data.company.License" size="small" placeholder="请输入许可证号"></el-input>
                </el-form-item>
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-upload
                      ref="uploadAdd"
                      action="/api/co/Attachment/UploadAttachment"
                      :before-upload="uploadBefore"
                      :on-success="function (res) { return uploadSuccess(res, 'uploadAdd')}"
                      :on-remove="uploadRemove"
                      :on-error="uploadError"
                      :file-list="showPicList"
                        list-type='text'
                      :limit="1"
                      :headers="{
                      AttachmentType:'12'
                      }"
                    >
                      <div class="upload">
                        <i class="el-icon-upload" >营业执照</i>
                        <div slot="tip">
                          <em style="font-size:5px;">图片文件不超过10MB</em>
                        </div>
                      </div>
                    </el-upload>
                  </el-col>
                  <el-col :span="8">
                    <div style="position: relative; left:110px;">
                      <el-upload
                        ref="uploadAdd"
                        action="/api/co/Attachment/UploadAttachment"
                        :before-upload="uploadBefore"
                        :on-success="function (res) { return uploadSuccess(res, 'uploadAdd')}"
                        :on-remove="uploadRemove"
                        :on-error="uploadError"
                        :file-list="showPicList"
                        list-type="text"
                        :limit="1"
                        :headers="{
                          AttachmentType:'13',
                        }"
                        >
                         <div class="upload">
                          <i class="el-icon-upload" >旅行社许可证</i>
                          <div slot="tip">
                            <em style="font-size:5px;">图片文件不超过10MB</em>
                          </div>
                        </div>
                      </el-upload>
                    </div>
                  </el-col>
                </el-row>
                <el-form-item prop="Fax" label="企业签章">
                  <br/>
                    <el-upload class="upload-demo" 
                    v-if="uploadView"
                    ref="upload"
                    action="" drag 
                    :auto-upload="false" 
                    :show-file-list="false" 
                    :before-upload="uploadBefore"
                    :on-change='handUpload'
                    :limit="1"
                    :headers="{
                    AttachmentType:'11',
                    }"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">点击上传</div>
                      <div class="el-upload__tip">支持绝大多数图片格式，单张图片最大支持10MB</div>
                    </el-upload>
                  <div class="imageDiv" v-else>
                    <i class="el-icon-delete" style="color:lightgreen;" @click="uploadRemove2"></i>
                    <el-image  :src="complementPicUrl(imageId)" fit="scale-down" style="height: 100%">
                       <div slot="placeholder">加载中....</div>
                    </el-image>
                  </div>          
                </el-form-item>
                <el-form-item prop="Fax" label="传真">
                  <el-input v-model="Data.company.Fax" size="small" placeholder="请输入传真"></el-input>
                </el-form-item>
                <el-form-item prop="PostCode" label="邮编">
                  <el-input v-model="Data.company.PostCode" size="small" placeholder="请输入邮编"></el-input>
                </el-form-item>
                <el-form-item prop="Email" label="邮箱">
                  <el-input v-model="Data.company.Email" size="small" type="Email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
                <el-form-item prop="ServiceTel" label="客服电话">
                  <el-input v-model="Data.company.ServiceTel" size="small" placeholder="请输入客服电话"></el-input>
                </el-form-item>
                <el-form-item prop="Address" label="地址">
                  <el-input v-model="Data.company.Address" size="small" placeholder="请输入地址"></el-input>
                </el-form-item>
                <el-form-item prop="NikeName" label="联系人">
                  <el-input v-model="Data.company.NikeName" placeholder="请输入联系人" size="small"></el-input>
                </el-form-item>
                <el-form-item prop="Tel1" label="联系方式">
                  <el-input v-model="Data.company.Tel1" size="small" placeholder="请输入联系方式"></el-input>
                </el-form-item>
                <el-form-item prop="checking" label="验证码">
                  <el-input v-model="Data.chenking" size="small" placeholder="请输入验证码" class="input"></el-input>
                  <div class="chenk">
                    <template>
                      <span v-show="show" @click="TELcheck">
                        <el-button type="primary" >获取验证码</el-button>
                      </span>
                      <span v-show="!show" class="count">{{count}} s后重试</span>
                    </template>
                  </div>
                </el-form-item>
                <el-form-item class="subform">
                  <el-button type="primary" @click="register('form')">确认提交</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <div>
                <ul>
                  <li class="words">已有账户</li>
                  <router-link to="/login" style=" color:green;">
                    直接登录
                    <i class="el-icon-right"></i>
                  </router-link>
                </ul>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
    <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
        <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :centerBox="option.centerBox"
            :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { validatePassword,validatePasswordNew,validateUsername,validateRegistCode,validatePhoneTwo,validateLicenseCode } from "../common/element-validator";
import { validatePhone } from "../common/element-validator";
import REGISTER from "../api/member";
import Attachment from "@/api/common";
import member from '../api/member';
import $ from 'jquery'
export default {
  name: "Regist",
  inject: ["voucher", "complementPicUrl"],
  data() {
    return {
      showPicList: [],
      show: true,
      count: "",
      timer: null,
      uploadView:true,
      imageId:'',
      listType:'picture',
      //裁剪
      dialogVisible: false,
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 300, // 默认生成截图框宽度
        // autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      picsList: [],  //页面显示的数组
      // 防止重复提交
      loading: false,

      Data: {
        company: {
          Name: "",
          RegistCode: "",
          License: "",
          Address: "",
          Fax: "",
          PostCode: "",
          Email: "",
          ServiceTel: "",
          Tel1: "",
          
          Uname: "",
          Pass: "",
          NikeName:"",
        },
        coMember: { Uname: "", Pass: "",NikeName:"", },
        Images: [], //附件图片
        Stamp:[],
        chenking: "",
      },

      formRules: {
        Uname: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { validator: validateUsername, trigger: "blur" },
        ],
        // Pass: [
        //   { required: true, validator: validatePassword, trigger: "blur" },
        //   { validator: validatePassword, trigger: "blur" },
        // ],
        Pass: [
          { required: true, validator: validatePasswordNew, trigger: "blur" },
          { validator: validatePasswordNew, trigger: "blur" },
        ],
        NikeName:[
          {required: true, message: "请输入联系人", trigger: "blur" }
        ],
        Name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        RegistCode: [
          { required: true, message: "请输入社会统一信用代码",trigger: "blur",},
          { validator: validateRegistCode, trigger: "blur" },
        ],
        License: [
          { required: true, message: "请输入许可证号", trigger: "blur" },
          { validator: validateLicenseCode, trigger: "blur" },
        ],
        Address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        ServiceTel: [
          { required: true, message: "请输入客服电话", trigger: "blur" },
          { validator: validatePhoneTwo, trigger: "blur" },
        ],
        Tel1: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
      },

      aStr:["弱", "中","高", "强"],
      strongText:"",
      imgTextUrl:"",//水印

      pwdType:"password",
    };
  },
  methods: {
    showPwd(){
      this.pwdType === 'password' ? this.pwdType = '' : this.pwdType = 'password';
      // let e = document.getElementsByClassName('el-icon-view')[0];
      let e=document.getElementById("PassView");
      this.pwdType == '' ? e.setAttribute('style', 'color: #409EFF') : e.setAttribute('style', 'color: #c0c4cc');
    },
    blurUserName(value){
      member.isRepeatUserName({UserName:value}).then(res=>{
        if(res.status==="fail"){
          this.$message.error(res.msg);  
        }
      })
    },
    blurRegistCodeName(value){
      member.isRepeatRegistCode({RegistCode:value}).then(res=>{
        if(res.status==="fail"){
          this.$message.error(res.msg);  
        }
      })
    },
    blurName(value){
      member.isRepeatName({CompanyName:value}).then(res=>{
        if(res.status==="fail"){
          this.$message.error(res.msg);  
        }
      })
    },
    handUpload(file){
      this.fileinfo = file;
      const isLt5M = file.size / 1024 / 1024 < 10
      if (!isLt5M) {
        this.$refs.upload.onError();
        this.$message.error('上传文件大小不能超过 10MB!');
        this.$refs.upload.clearFiles();
        return false;
      }
      let fileType = file.raw.type,
      isImage = fileType.indexOf("image") != -1 ;
      if (!isImage) {
        this.$refs.upload.onError();
        this.$message.error("只能上传图片！");
        this.$refs.upload.clearFiles();
        return false;
      }
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.option.img = window.URL.createObjectURL(file.raw)
        this.dialogVisible = true;
        this.$refs.upload.clearFiles(); // 清空文件
      })
    },
    // 上传按钮   限制图片大小
    changeUpload(file, fileList) {
      const isLt5M = file.size / 1024 / 1024 < 10
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 10MB!')
        return false
      }
    
      this.fileinfo = file
     
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
      
        this.option.img = window.URL.createObjectURL(file.raw)
        this.dialogVisible = true
      })
    },

    blobToImg (blob) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.addEventListener('load', () => {
          let img = new Image()
          img.src = reader.result
          img.addEventListener('load', () => resolve(img))
        })
        reader.readAsDataURL(blob)
      })
    },
    //添加水印
    watermark (canvas, text) {
      return new Promise((resolve, reject) => {
        // let ctx = canvas.getContext('2d')
        var canvasWidth = canvas.width;
        var context = canvas.getContext("2d"); 
        // 设置填充字号和字体，样式
        context.fillStyle = '#B5B5B5';
        var x = -300;
        var y = 2000;
        context.font = "280px 微软雅黑";
        context.rotate(-15 * Math.PI / 180);
        var textWidth = context.measureText("苏州旅游团队电子行程单").width;
        if(textWidth>canvasWidth) {
          var scaled = canvasWidth/textWidth;
          context.scale(scaled,scaled);
        }
        //x,y用于居中， canvas第一次使用，搞不明白x,y用的是什么单位，所以写死在这里了。
        context.fillText("苏州旅游团队电子行程单", x, y);
        canvas.toBlob(blob => resolve(blob))
      })
    },
    imgToCanvas (img) {
      let canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      let ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      return canvas
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {     
      this.loading = true;
      this.imageId = '';
      let fd = new FormData();
      var bl="";
      this.$refs.cropper.getCropBlob((data) => {
        var fileName = this.fileinfo.name;      
        this.blobToImg(data).then(res=>{
          let canvas = this.imgToCanvas(res);
          this.watermark(canvas, "苏州旅游团队电子行程单").then(res2=>{
            fd.append("picturefile", res2, fileName);
            const config = {
            headers: {'Content-Type': 'multipart/form-data','AttachmentType':'11'}
        };     
        this.$http.post('/api/co/Attachment/UploadAttachment', fd, config).then(resp => {          
            if (resp.data.status === 'success') {
                this.loading = false;
                this.dialogVisible = false;
                this.uploadView = false;
                this.$message.success("上传成功！");
                this.Data.Stamp.push(resp.data.content);
                this.imageId = resp.data.content;
              } else {
                this.$refs[uploadName].onError();
              }
        }).catch(err => {
           
        });
          })
          
        })
      })
    },

    //注册用户
    register(formName) {
      var _self=this;
      _self.$refs[formName].validate((success) => {
        if (success) {
          if(_self.strongText!="强"){
            // this.$message.error("密码需为6-17为大写字母、小写字母、数字及英文符合组合!");
            _self.$message.error("密码需为8位及以上的大小写字母、数字及特殊符合组合!");
            return false;
          }
          if (_self.Data.Images.length <2) {
            _self.$message.error("旅行社许可证或营业执照未上传！");
            return false;
          }
          if (_self.Data.Stamp.length == 0) {
            _self.$message.error("请上传企业签章");
            return false;
          }
          if(_self.Data.chenking=="" || _self.Data.chenking==null){
            _self.$message.error("请获取验证码!");
            return false;
          }
          _self.Data.coMember = {
            Uname: _self.Data.company.Uname,
            NikeName:_self.Data.company.NikeName,
            Pass: _self.Data.company.Pass,
          };
          REGISTER.register(_self.Data).then((res) => {
            if (res.status === "success") {
              _self.$message.success("注册成功,请等待审核通过后再进行登录!");
              _self.$router.push("/login");
            } else {
              _self.$message.error(res.msg);
            }
          });
        } else {
          _self.$message.error("信息填写不完整！");
        }
      });
    },
    //验证码验证getCode
    TELcheck() {
      var _self=this;
      if (!_self.Data.company.Tel1) {
        _self.$message.error("未获取到联系方式!");
        return;
      }
      REGISTER.getCode({ tel: _self.Data.company.Tel1 }).then((res) => {
        if (res.status === "success") {
          _self.$message.success("获取成功");

          const TIME_COUNT = 60;
          if (!_self.timer) {
            _self.count = TIME_COUNT;
            _self.show = false;
            _self.timer = setInterval(() => {
              if (_self.count > 0 && _self.count <= TIME_COUNT) {
                _self.count--;
              } else {
                _self.show = true;
                clearInterval(_self.timer);
                _self.timer = null;
              }
            }, 1000);
          }
        } else {
          _self.$message.error(res.message);
        }
      });
    },

    //图片上传之前判断
    uploadBefore(file) {
      let fileType = file.type,
        isImage = fileType.indexOf("image") != -1,
        isPdf = fileType.indexOf("pdf") != -1,
        isBig = file.size <= 1024 * 1024 * 10;
      if (!file) {
        this.$refs.upload.onError();
        this.$message.error("上传为空！");
        return false;
      }
      if (!isImage&&!isPdf) {
        this.$refs.upload.onError();
        this.$message.error("只能上传图片或PDF文件！");
        return false;
      }
      if (!isBig) {
        this.$refs.upload.onError();
        this.$message.error("图片大小不能超过10MB！");
        return false;
      }
      return true;
    },
    //图片上传成功之后回传
    uploadSuccess(res, uploadName) {
      if (res.status === "success") {
        this.$message.success("上传成功！");
        this.Data.Images.push(res.content);
      } else {
        this.$refs[uploadName].onError();
      }
    },
    //图片上传失败
    uploadError() {
      this.$message.error("上传失败！");
    },
    //图片移除
    uploadRemove(file) {
      Attachment.deleteAttachment({
        AttachmentStatus: -1,
        AttachmentId: file.response.content,
      }).then((res) => {
        if (res.status === "success") {
          this.$message.success("删除成功");
        } else {
          this.$message.error("删除失败");
        }
      });
    },
    //图片移除
    uploadRemove2(){
      Attachment.deleteAttachment({
        AttachmentStatus: -1,
        AttachmentId: this.imageId,
      }).then((res) => {
        if (res.status === "success") {
          this.$message.success("删除成功");
          this.imageId='';
          this.uploadView=true;
        } else {
          this.$message.error("删除失败");
        }
      });
    },

    //密码强度检测
    checkStrong(val){
      var modes = 0;
      // if (val.length < 6) return 0;
      // if (/\d/.test(val)) modes++; //数字
      // if (/[a-z]/.test(val)) modes++; //小写
      // if (/[A-Z]/.test(val)) modes++; //大写 
      // if (/\W/.test(val)) modes++; //特殊字符
      // if (val.length > 17) return 4;

      if (val.length < 8) return 0;
      if (/\d/.test(val)) modes++; //数字
      if (/[a-z]/.test(val)) modes++; //小写
      if (/[A-Z]/.test(val)) modes++; //大写 
      if (/\W/.test(val)) modes++; //特殊字符
      
      // if (val.length > 17) return 4;
      return modes;
    },
  },
  created(){
  },
  watch:{
    "Data.company.Pass":function(val){
      var _self=this;
      var num = _self.checkStrong(val);
      //强度  否则 undefined
      _self.strongText=_self.aStr[num - 1];
      switch(num){
        case 0:
          $("#tips span").css('background', 'green').text('');
          break;
        case 1:
          $("#tips span").css('background', 'yellow').text('').eq(num - 1).css('background', 'red').text(_self.aStr[num - 1]);
          break;
        case 2:
          $("#tips span").css('background', 'green').text('').eq(num - 1).css('background', 'red').text(_self.aStr[num - 1]);
          break;
        case 3:
          $("#tips span").css('background', 'green').text('').eq(num - 1).css('background', 'red').text(_self.aStr[num - 1]);
          break;
        case 4:
          $("#tips span").css('background', 'green').text('').eq(num - 1).css('background', 'red').text(_self.aStr[num - 1]);
          break;
        default:
          $("#tips span").css('background', 'green').text('');
          break;
      }

    },
  },
};
</script>

<style scoped lang="less">
#tips {
  float: left;
  margin: 2px 0 0 0;
}
 
#tips span {
  float: left;
  width: 50px;
  height: 20px;
  color: white;
  background: green;
  margin-right: 2px;
  line-height: 20px;
  text-align: center;
}


.imageDiv{
  position: relative;
  font-size: 25px;
  width: 50%;
  height: 50%;
  .el-icon-delete:before {
    content: "\e6d7";
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 99999;
    
  }
}
.cropper-content {
    .cropper {
        width: auto;
        height: 300px;
    }
}

// .el-upload__text[data-v-a464e1a0]{
//   width: 100%;
// }
.regist-content {
  width: 100%;
  height: 150px;
  background-color: #00acc1;
  min-width: 1990px;
}
.subform {
  width: 100px;
  position: relative;
  left: 80%;
  top: 5px;
}
.regist-title {
  color: white;
  font-size: 41px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 56px;
  letter-spacing: 4px;
  color: #ffffff;
  text-shadow: 1px 1px 6px #8c8585;
  font-family: MicrosoftYaHei-Bold;
}
.input {
  width: 310px;
  margin-right: 20px;
}
.regist-title p {
  position: absolute;
  width: 20%;
  left: 28%;
  top: 50px;
  min-width: 400px;
}

.box-card {
  width: 1100px;
  position: absolute;
  left: 28%;
  top: 120px;
}
.queryform {
  position: relative;
  left: 5%;
}
.word {
  color: #49a71b;
}
ul {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 3px;
  color: #1b9dd9;
  cursor: pointer;
  position: relative;
  top: 20px;
  line-height: 25px;
}
.chenk {
  position: relative;
  top: -40px;
  left: 380px;
  width: 110px;
  height: 40px;
  border-radius: 10px;
  text-align: center;
  background-color: rgb(211, 209, 209);
}
.words {
  color: black;
}
.words-item {
  color: black;
  margin-top: 20px;
}
// .el-upload__text {
//   font-size: 16px;
//   position: relative;

//   width: 150px;
//   height: 30px;
// }

.el-upload-list__item is-success{
  background-color: #49a71b;
}
.upload{
  border:1px dotted #e93f3f;
  height:120px;
  text-align:center;
  border-radius:5px;
  width:200px;
  padding-bottom: 10px;
  .el-icon-upload{
    line-height:60px; font-size:16px
  }
}


</style>
